import * as React from "react";
import {Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from "@material-ui/core";

import emptyList from "../../assets/lottie/empty-list_1.json";
import {useLoadingState} from "../../context/LoadingContext";
import {css} from "@emotion/css";
import {convertCurrencyFormatPositiveNegative} from "../../utils/numberConvertor";
import {Player} from "@lottiefiles/react-lottie-player";

export const CustomTable = ({header, data, rowClicked, title, summation}) => {
    const loading = useLoadingState()

    const defaultOptionsNotFound = {
        loop: true,
        autoplay: true,
        animationData: emptyList,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };


    return (
        <Card className='flex-grow-1 d-flex flex-column' style={{borderRadius: '25px'}}
              variant='outlined'>
            {data.length > 0 ?

                <TableContainer className='hideScroll flex-grow-1 hideScrollBar h-100 d-flex flex-column'>
                    <div className="flex-grow-1 w-100">
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow
                                >
                                    {header.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{minWidth: column.minWidth}}
                                        >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data
                                    .map((row, index) => {
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={row.id}
                                                className={typeof rowClicked === "undefined" ? "" : "cursorPointer"}
                                                onClick={_ => {
                                                    if (typeof rowClicked !== 'undefined') {
                                                        rowClicked(row.id, index)
                                                    }
                                                }}
                                            >
                                                {header.map((column) => {
                                                    const value = row[column.id];
                                                    return (
                                                        <TableCell
                                                            key={column.id}
                                                            align={column.align}
                                                            className='font_primary_regular'
                                                        >
                                                            {
                                                                column.format && typeof value === 'number'
                                                                    ? column.format(value)
                                                                    : value}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </div>
                    <div
                        className={summation ? css`
                          width: 100%;
                          position: sticky;
                          bottom: 0;
                          padding: 16px;
                          background: rgba(255, 255, 255, 0.5);
                          display: flex;
                          flex-direction: row;
                          justify-content: right;
                          border-top: 1px solid rgba(224, 224, 224, 1);
                          gap: 8px;
                        ` : "d-none"}>
                        <span className={css`font-size: 14px;`}>مجموع :</span>
                        <span className={css`direction: ltr;`}>{convertCurrencyFormatPositiveNegative(summation)}</span>
                        <span className={css`font-size: 14px;`}>ریال</span>
                    </div>
                </TableContainer>

                :
                <div className='w-100 h-100' style={{display: 'grid', placeItems: 'center'}}>
                    {loading.loading ?
                        /*<section className='d-flex flex-column'>
                            <Lottie
                                options={defaultOptions}
                                // height={80}
                                width='400px'
                            />
                        </section>*/
                        "" :
                        <section className='d-flex flex-column'
                                 style={{justifyContent: 'center', alignItems: 'center'}}>
                            <Player
                                style={{width: '100%'}}
                                loop
                                autoplay
                                className="player"
                                src={emptyList}
                            />
                            <Typography className='mt-1 mb-3 py-3' style={{marginTop: '1rem'}} variant='inherit'>
                                {title ? title : "هیچ اطلاعاتی یافت نشد !"}
                            </Typography>
                        </section>
                    }
                </div>
            }
        </Card>

    )
};
export default CustomTable
